import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { LabelSettings } from '@progress/kendo-angular-progressbar';

@Component({
	selector: 'kpa-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {
	@Input() currentQuestionsPerPage: number;
	@Input() currentQuestion: number;
	@Input() minimumQuestions: number;
	@Input() maximumQuestions: number;
	@Input() isItemChangeValid: boolean | null = null;

	@Output() validateRequest: EventEmitter<number> = new EventEmitter<number>();
	@Output() submitAudit: EventEmitter<number> = new EventEmitter<number>();
	@Output() onItemChange: EventEmitter<number> = new EventEmitter<number>();
	public questionsPerPage: Array<{ text: string; value: number }> = [
		{ text: '1', value: 1 },
		{ text: '5', value: 5 },
		{ text: '10', value: 10 },
		{ text: '15', value: 15 },
	];
	public label: LabelSettings = {
		visible: false,
	};
	selectedItem = this.questionsPerPage[0];
	previousSelectedItem = this.questionsPerPage[0];
	constructor(private cdr: ChangeDetectorRef) {}
	public setItems(event: any): void {
		this.previousSelectedItem = this.selectedItem;
		this.selectedItem = this.questionsPerPage.find((x) => x.value == event.value);
		this.onItemChange.emit(event.value);
	}

	ngOnChanges() {
		if (this.isItemChangeValid === false) {
			this.cdr.detectChanges();
			this.selectedItem = this.questionsPerPage.find((item) => item.value === this.previousSelectedItem.value);
		}
	}
	onNextClick() {
		this.validateRequest.emit(this.currentQuestion + 1);
	}

	onPrevClick() {
		this.validateRequest.emit(this.currentQuestion - 1);
	}
	onSubmitClick() {
		this.submitAudit.emit(this.currentQuestion);
	}
	maxPageNumber() {
		return Math.ceil(this.maximumQuestions / this.currentQuestionsPerPage);
	}
}
